import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { addDays, endOfDay, isBefore, startOfDay } from 'date-fns';

export function maxDateValidator(max: Date): ValidatorFn {
    return (control: AbstractControl<Date>): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }

        const valid = isBefore(startOfDay(value), endOfDay(max));
        return valid
            ? null
            : { maxDate: { value: addDays(max, 1).toLocaleDateString() } };
    };
}
